import {withRouter} from 'react-router-dom'

import {HiFire, HiHome} from 'react-icons/hi'
import {SiYoutubegaming} from 'react-icons/si'
import {MdPlaylistAdd} from 'react-icons/md'

import NxtWatchContext from '../../NxtWatchContext/NxtWatchContext'

import {
  MenuListContainer,
  MenuAndContactContainer,
  ContactImg,
  ContactMediaContainer,
  ContactHeading,
  ContactContainer,
  MenuOptionContent,
  MenuItemBtn,
  SelectedBtn,
  GreetingsContent,
  MenuItem,
  LinkEl,
  Icon,
  SelectedIcon,
} from './styledComponents'

const menuItems = {
  home: 'Home',
  trending: 'Trending',
  gaming: 'Gaming',
  savedVideos: 'Saved Videos',
}

const Sidebar = props => {
  const {match} = props
  const {path} = match

  let selectedMenuItem = ''
  if (path === '/') {
    selectedMenuItem = menuItems.home
  } else if (path === '/trending') {
    selectedMenuItem = menuItems.trending
  } else if (path === '/gaming') {
    selectedMenuItem = menuItems.gaming
  } else if (path === '/saved-videos') {
    selectedMenuItem = menuItems.savedVideos
  }

  return (
    <NxtWatchContext.Consumer>
      {value => {
        const {darkMode} = value

        const renderRespectiveIcon = option => {
          if (option === menuItems.home) {
            return selectedMenuItem === menuItems.home ? (
              <SelectedIcon darkMode={darkMode}>
                <HiHome />
              </SelectedIcon>
            ) : (
              <Icon darkMode={darkMode}>
                <HiHome />
              </Icon>
            )
          }
          if (option === menuItems.trending) {
            return selectedMenuItem === menuItems.trending ? (
              <SelectedIcon darkMode={darkMode}>
                <HiFire />
              </SelectedIcon>
            ) : (
              <Icon darkMode={darkMode}>
                <HiFire />
              </Icon>
            )
          }
          if (option === menuItems.gaming) {
            return selectedMenuItem === menuItems.gaming ? (
              <SelectedIcon darkMode={darkMode}>
                <SiYoutubegaming />
              </SelectedIcon>
            ) : (
              <Icon darkMode={darkMode}>
                <SiYoutubegaming />
              </Icon>
            )
          }
          return selectedMenuItem === menuItems.savedVideos ? (
            <SelectedIcon darkMode={darkMode}>
              <MdPlaylistAdd />
            </SelectedIcon>
          ) : (
            <Icon darkMode={darkMode}>
              <MdPlaylistAdd />
            </Icon>
          )
        }

        const renderRespectiveBtn = option => {
          const status = selectedMenuItem === option
          if (status === true) {
            return (
              <SelectedBtn type="button" darkMode={darkMode}>
                <Icon isSelected={status}>{renderRespectiveIcon(option)}</Icon>
                <MenuOptionContent>{option}</MenuOptionContent>
              </SelectedBtn>
            )
          }
          return (
            <MenuItemBtn type="button" darkMode={darkMode}>
              <Icon isSelected={status}>{renderRespectiveIcon(option)}</Icon>
              <MenuOptionContent>{option}</MenuOptionContent>
            </MenuItemBtn>
          )
        }
        return (
          <MenuAndContactContainer darkMode={darkMode}>
            <MenuListContainer>
              <LinkEl to="/">
                <MenuItem>{renderRespectiveBtn(menuItems.home)}</MenuItem>
              </LinkEl>
              <LinkEl to="/trending">
                <MenuItem>{renderRespectiveBtn(menuItems.trending)}</MenuItem>
              </LinkEl>
              <LinkEl to="/gaming">
                <MenuItem>{renderRespectiveBtn(menuItems.gaming)}</MenuItem>
              </LinkEl>
              <LinkEl to="/saved-videos">
                <MenuItem>
                  {renderRespectiveBtn(menuItems.savedVideos)}
                </MenuItem>
              </LinkEl>
            </MenuListContainer>
            <ContactContainer>
              <ContactHeading darkMode={darkMode}>CONTACT US</ContactHeading>
              <ContactMediaContainer>
                <ContactImg
                  src="https://assets.ccbp.in/frontend/react-js/nxt-watch-facebook-logo-img.png"
                  alt="facebook logo"
                />
                <ContactImg
                  src="https://assets.ccbp.in/frontend/react-js/nxt-watch-twitter-logo-img.png"
                  alt="twitter logo"
                />
                <ContactImg
                  src="https://assets.ccbp.in/frontend/react-js/nxt-watch-linked-in-logo-img.png"
                  alt="linked in logo"
                />
              </ContactMediaContainer>
              <GreetingsContent darkMode={darkMode}>
                Enjoy! Now to see your channels and recommendations!
              </GreetingsContent>
            </ContactContainer>
          </MenuAndContactContainer>
        )
      }}
    </NxtWatchContext.Consumer>
  )
}
export default withRouter(Sidebar)
